$(document).ready(function(e) {
	
	$(".btn_scorall").click(function() {
		$('html, body').animate({
			scrollTop: $("#getOrder").offset().top - 50
		}, 2000);
	});
	
	$('.s2-slide-div').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.s2-slider-nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
		responsive: [
			{
				breakpoint: 1024,
				settings: {slidesToShow: 2}
			},
			
			{
				breakpoint: 767,
				settings:{slidesToShow: 1, dots:false, arrows:true,}
				
			}
		]
	});

	$('.s2-slider-nav').slick({
		slidesToShow:3,
		slidesToScroll: 1,
		asNavFor: '.s2-slide-div',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		arrows: false,
	});
	
		
	$('.package_slider').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		arrows: false,
		fade: false,
		asNavFor: '.package_slider_nav',
		autoplay: false,
		autoplaySpeed: 11000,
		dots: false,
	});

	$('.package_slider_nav').slick({
		slidesToShow:6,
		slidesToScroll: 1,
		asNavFor: '.package_slider',
		dots: false,
		centerMode: false,
		focusOnSelect: true,
		infinite: true,
		arrows: false,
	});	
		
	//<!-------------PKG_OPT-------------------->
	$('.prd-opt').click(function(e) {
       $('.prd-opt').removeClass('active');
	   $(this).addClass('active');
    });
	
	$('.prd-opt').click(function(e) {
		if (!$(this).find(".pck-bx-rad").attr("checked")) {
			$(this).parent('.selectBox').find(".pck-bx-rad").removeAttr("checked");
			$(this).find(".pck-bx-rad").attr("checked", "checked");
		}
		
		$('.cut-price').html($(this).attr("data-retail"));
		$('.total-price').html($(this).attr("data-total"));
	});
		


	$('.option_row').click(function(e) {
		$('.option_row').removeClass('active');
		$(this).addClass('active');
        $(this).parent('.package_row').find(".pck-bx-rad").removeAttr("checked");
	});
	
	$('.extra-opt').click(function(e) {
        $('.package_col').removeClass('active');
		$('.regular-pkg').hide();
		$('.extra-pkg').fadeIn();
        $('.package_col.pckex3').addClass('active');
        $('.pckex3 .radio_opt .pck-bx-rad').prop('checked', true).trigger('change');
        updateCartButtonUrl();        
	});
	
	$('.regular-opt').click(function(e) {
        $('.package_col').removeClass('active');
		$('.regular-pkg').fadeIn();
		$('.extra-pkg').hide();
        $('.package_col.pckreg3').addClass('active');
        $('.pckreg3 .radio_opt .pck-bx-rad').prop('checked', true).trigger('change');
        updateCartButtonUrl();
	});
	

	$('.package_col').click(function(e) {
		if (!$(this).find(".pck-bx-rad").attr("checked")) {
			$(this).parent('.package_row').find(".pck-bx-rad").removeAttr("checked");
			$(this).find(".pck-bx-rad").attr("checked", "checked");
		}
	});
	
	$('.package_col').click(function(e) {
		$(this).closest('.package_row').find('.package_col').removeClass('active');
		$(this).addClass('active');	
	});




    
    updateCartButtonUrl();

    // Handle clicking on a package option
    $('.package_col').click(function() {
        $('.package_col').removeClass('active');
        $(this).addClass('active');

        // Ensure the corresponding radio button is checked
        $(".pck-bx-rad").prop("checked", false);
        $(this).find(".pck-bx-rad").prop("checked", true).trigger('change');

        // Update displayed prices and URLs when a new package is selected
        // updateDisplayedPrices();
        updateCartButtonUrl();
    });

    // Function to set the URL for the "Add to Cart" button
    function updateCartButtonUrl() {
        const selectedPackage = $('.package_col.active').find('.pck-bx-rad').data('package');
        if (selectedPackage) {
            const baseCartUrl = "https://db0aca-7e.myshopify.com/cart/";

            const params = new URLSearchParams(window.location.search);
            params.set('channel', 'buy_button');

            const discountCode = $('.package_col.active').data('discount-code') || '';
            params.set('discount', discountCode);

            const finalUrl = `${baseCartUrl}${selectedPackage}?${params.toString()}`;

            $('.cart_common_btn').off('click').on('click', function(event) {
                event.preventDefault();
                window.location.href = finalUrl;
                // console.log("Sent", finalUrl)
            });
        }
    }
			
	//accordion JS 
	$(".acdn-heading").click(function() {
			
		var questionDiv = $(this);
		var answerDiv   = $(this).next('.acdn-content');
		var idx = $('.acdn-content').index(answerDiv);
		
		$('.acdn-content').each(function(index, ansDiv) {
			if(index != idx && $(ansDiv).is(':visible')) {
				$(ansDiv).slideUp(500, function() {
					$(ansDiv).prev('.acdn-heading').removeClass('accordion-open');
				});
			}
		});
					
		if (answerDiv.is(':visible')) {
			answerDiv.stop().slideUp(500, function() {
				questionDiv.removeClass('accordion-open');
			});
		} else {
		  questionDiv.addClass('accordion-open');
		  answerDiv.stop().slideDown(500);
		}
		
	});
	
});

function isScrolledIntoView(elem) {
	var docViewTop = $(window).scrollTop();
	var docViewBottom = docViewTop + $(window).height();
	
	var elemTop = $(elem).offset().top;
	var elemBottom = elemTop + $(elem).height();
	
	return ((elemTop <= docViewBottom) && (elemBottom >= docViewTop));
}

$(document).scroll(function() {
		
	if ($(this).scrollTop() > 40){
		$('.top-fix-bar').addClass('fixed-nav');
	}else{
		$('.top-fix-bar').removeClass('fixed-nav');
	}
	
	var $elem = $('.fixed_btn');
	var $window = $(window);

	var docViewTop = $window.scrollTop();
	var docViewBottom = docViewTop + $window.height();

	var elemTop = $elem.offset().top;
	var elemBottom = elemTop + $elem.height();

	if (elemTop >= (docViewBottom + 20) || (elemTop + $('#call-btn').height()) >= (docViewBottom + 104)) {
			
		if (isScrolledIntoView('.section8') === true) {
			$('#call-btn').css('position', 'relative');
			
		} else {
			$('#call-btn').css('position', 'fixed');
		}
	} else {
		$('#call-btn').css({'position' : 'relative'});
	}
	
});


function getTimeRemaining(endtime) {
	  var t = Date.parse(endtime) - Date.parse(new Date());
	  var seconds = Math.floor((t / 1000) % 60);
	  var minutes = Math.floor((t / 1000 / 60) % 60);
	  var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
	  var days = Math.floor(t / (1000 * 60 * 60 * 24));
	  return {
		'total': t,
		'days': days,
		'hours': hours,
		'minutes': minutes,
		'seconds': seconds
	  };
	}
function initializeClock(id, endtime) {
    var clock = document.getElementById(id);
    // var daysSpan = clock.querySelector('.days');
    var hoursSpan = clock.querySelector('.hours');
    var minutesSpan = clock.querySelector('.minutes');
    var secondsSpan = clock.querySelector('.seconds');

    function updateClock() {
    var t = getTimeRemaining(endtime);

    // daysSpan.innerHTML = t.days;
    hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);

    if (t.total <= 0) {
        clearInterval(timeinterval);
    }
    }

    updateClock();
    var timeinterval = setInterval(updateClock, 1000);
}

var deadline = new Date(Date.parse(new Date()) + 360 * 100 * 1000);

initializeClock('clockdiv', deadline);